import { render, staticRenderFns } from "./TagLink.vue?vue&type=template&id=4391a633"
import script from "./TagLink.vue?vue&type=script&lang=js"
export * from "./TagLink.vue?vue&type=script&lang=js"
import style0 from "./TagLink.vue?vue&type=style&index=0&id=4391a633&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports